var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassMenu",
        {
          attrs: {
            trigger: "click",
            placement: "left-start",
            "custom-class": "doc-overview-context-menu"
          },
          scopedSlots: _vm._u([
            {
              key: "dropdown",
              fn: function() {
                return [
                  _c("CompassMenuItem", {
                    attrs: { label: _vm.$t.__("common.actions.edit") },
                    on: {
                      click: function($event) {
                        return _vm.$emit("update")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: { label: _vm.$t.__("common.actions.unlink") },
                    on: {
                      click: function($event) {
                        return _vm.$emit("unlink")
                      }
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [_c("CompassIconButton", { attrs: { icon: "action" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }